<div class="filter-main-container" *ngIf="!showManageFilters">
  <div class="header">
    <div fxLayout="row">
      <button
        class="left-drawer-toggle"
        mat-icon-button
        matTooltip="Hide Quick Filters"
        matTooltipShowDelay="500"
        (click)="toggleQuickFiltersClick()"
        aria-label="Toggle visibility of quick filters"
      >
        <mat-icon *ngIf="leftDrawerOpen">chevron_left</mat-icon>
        <mat-icon *ngIf="!leftDrawerOpen">chevron_right</mat-icon>
      </button>
      <h3 [fxHide]="!leftDrawerOpen">Quick Filters</h3>
    </div>
    <button
      [fxHide]="!leftDrawerOpen"
      mat-icon-button
      [matMenuTriggerFor]="menu"
      matTooltip="More actions"
      aria-label="More actions"
      matTooltipShowDelay="500"
    >
      <mat-icon>more_vert</mat-icon>
      <mat-menu #menu="matMenu">
        <button mat-menu-item (click)="showManageFilters = true">
          <span>Customize Quick Filters</span>
        </button>
      </mat-menu>
    </button>
  </div>
  <mat-divider [fxHide]="!leftDrawerOpen"></mat-divider>
  <div class="filter-content" [fxHide]="!leftDrawerOpen">
    <ng-scrollbar>
      <div class="filters">
        <quick-odata-filter-item
          *ngFor="let filterItem of filterItems | orderBy: 'rank'"
          [filterItem]="filterItem"
          (addFilter)="onAdd($event)"
          (removeFilter)="onRemove($event)"
        ></quick-odata-filter-item>
      </div>

      <button class="show-button" color="primary" mat-button *ngIf="filterItems.length" (click)="showAllFilters.emit()">
        VIEW ALL FILTERS
      </button>
    </ng-scrollbar>
  </div>
</div>
<manage-qiuck-odata-filters
  [filters]="filterCollection"
  [quickFilters]="filterItems"
  *ngIf="showManageFilters"
  (cancel)="showManageFilters = false"
  (apply)="applyManageFilterResult($event)"
></manage-qiuck-odata-filters>
